import * as moment from "moment";
import { PerfilBusqueda } from "src/app/model/session/perfil-busqueda.model";

export class BuscarPersona {
  public Nombre: string;
  public SNombre: string;
  public ApellidoPaterno: string;
  public ApellidoMaterno: string;
  public PersonalidadFiscalId: number;
  public RFC: string;
  public ClaveCia: string;
  public NoCuenta: string;
  public EstatusId: number;
  public AreaId: number;
  public SucursalId: number;
  public TipoPersona: number;
  public Historico: number;
  public Pagina: number;

  public FechaInicialRegistro: string;
  public FechaFinalRegistro: string;

  public BatchNumber: number;
  public BatchSize: number;

  public TipoConsulta: number;

  constructor() {
    const FORMATO_SALIDA = "YYYY-MM-DD";
    const FORMATO_ENTRADA = "YYYY-MM-DDTHH:mm:ss Z";
    const fechainicial = moment(new Date(2018, 11, 12), FORMATO_ENTRADA);
    const fechafinal = moment(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      FORMATO_ENTRADA,
    );
    this.FechaInicialRegistro = fechainicial.format(FORMATO_SALIDA);
    this.FechaFinalRegistro = fechafinal.format(FORMATO_SALIDA);
    this.PersonalidadFiscalId = -1;
    this.Pagina = 1;
    this.Nombre = "";
    this.SNombre = "";
    this.ApellidoPaterno = "";
    this.ApellidoMaterno = "";
    this.EstatusId = -1;
    this.AreaId = -1;
    this.Historico = 0;
    this.SucursalId = -1;
  }
}
